import './bootstrap';
import SweetAlert from '../webstore/utilities/sweetalert.js';
import initDateTimePicker from "./picker.js";
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

const initialSlide = $('.swiper .active-slide').data('slide-index') ?? 0

new Swiper('.swiper', {
    modules: [Navigation, Pagination],
    direction: 'horizontal',
    slidesPerView: "auto",
    slidesPerGroup: 1,
    initialSlide: initialSlide,
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    on: {
        init: function () {
            this.el.classList.remove('swiper-loading')
        }
    }
});

const $body = $('body')

class MobileNavigation {
    constructor() {
        this.selectors = {
            mobileVersion: '.mobile-version',
            hamburgerToggle: '#hambugerToggle',
            dropdownMenu: '#dropdownMenu',
            searchBar: '#searchBar',
            searchIcon: '#search-icon',
            cartIcon: '#cart-icon',
            cartBadge: '.cart-badge',
            searchBtn: '#search-btn',
        };

        this.state = {
            isMenuOpen: false,
            isSearchOpen: false
        };

        this.init();
    }

    init() {
        this.cacheElements();
        this.setupEventListeners();
        this.setupClickOutsideListener();
    }

    cacheElements() {
        this.elements = {
            mobileVersion: document.querySelector(this.selectors.mobileVersion),
            hamburgerToggle: document.querySelector(this.selectors.hamburgerToggle),
            dropdownMenu: document.querySelector(this.selectors.dropdownMenu),
            searchBar: document.querySelector(this.selectors.searchBar),
            searchIcon: document.querySelector(this.selectors.searchIcon),
            cartIcon: document.querySelector(this.selectors.cartIcon)
        };
    }

    setupEventListeners() {
        if (this.elements.hamburgerToggle) {
            this.elements.hamburgerToggle.addEventListener('click', (e) => {
                e.stopPropagation();
                this.toggleMenu()
                this.elements.hamburgerToggle.classList.toggle('active');

                if (this.elements.searchIcon) {
                    this.elements.searchIcon.classList.remove('active');
                    this.closeSearch();
                }
            });
        }

        if (this.elements.searchIcon) {
            this.elements.searchIcon.addEventListener('click', (e) => {
                e.stopPropagation();
                this.elements.searchIcon.classList.toggle('active');
                this.toggleSearch()
            });
        }

        if (this.elements.dropdownMenu) {
            this.setupDropdownOptions();
        }
    }

    setupClickOutsideListener() {
        document.addEventListener('click', (e) => {
            // Check if click is outside search elements
            const isClickInsideSearch = this.elements.searchIcon.contains(e.target) ||
                (this.elements.searchBar && this.elements.searchBar.contains(e.target));

            if (!isClickInsideSearch && this.state.isSearchOpen) {
                this.closeSearch();
                this.elements.searchIcon.classList.remove('active');
            }
        });
    }

    toggleMenu() {
        this.state.isMenuOpen = !this.state.isMenuOpen;

        if (this.state.isMenuOpen) {
            this.closeSearch();
        }

        this.updateMenuState();
        this.updateBodyScroll();
    }

    toggleSearch() {

        if (this.state.isSearchOpen) {
            this.closeMenu();
        }

        this.state.isSearchOpen = !this.state.isSearchOpen;

        this.updateSearchState();
    }

    closeMenu() {
        this.state.isMenuOpen = false;
        this.updateMenuState();
        this.updateBodyScroll();
    }

    closeSearch() {
        this.state.isSearchOpen = false;
        this.updateSearchState();
    }

    updateMenuState() {
        if (this.elements.dropdownMenu) {
            this.elements.dropdownMenu.classList.toggle('open', this.state.isMenuOpen);
        }

        if (this.elements.mobileVersion) {
            this.elements.mobileVersion.classList.toggle('active', this.state.isMenuOpen);
        }
    }

    updateSearchState() {
        if (this.elements.searchBar) {
            this.elements.searchBar.classList.toggle('active', this.state.isSearchOpen);
        }
    }

    updateBodyScroll() {
        $body.toggleClass('overflow-hidden', this.state.isMenuOpen)
    }

    setupDropdownOptions() {
        const options = this.elements.dropdownMenu.querySelectorAll('.dropdown-option');

        options.forEach(option => {
            option.addEventListener('click', () => {
                options.forEach(opt => opt.classList.remove('bold'));
                option.classList.add('bold');
            });
        });
    }

}

function navbarHighlight() {
    // Navbar selection script: highlights active link
    const currentUrl = window.location.href;
    document.querySelectorAll('.nav-bar-names').forEach(link => {
        link.addEventListener('click', () => {
            document.querySelectorAll('.nav-bar-names').forEach(el => el.classList.remove('selected'));
            link.classList.add('selected');
        });
    });
}


function mapScript() {
    //Map Script
    document.querySelectorAll('.product-names').forEach(el => {
        el.addEventListener('click', () => {
            document.querySelectorAll('.product-names').forEach(e => e.classList.remove('active'));
            el.classList.add('active');
        });
    });
}

function setupOrderCounter() {
    document.querySelectorAll('.quantity').forEach(wrapper => {
        const minusBtn = wrapper.querySelector('.qty-btn-minus');
        const plusBtn = wrapper.querySelector('.qty-btn-plus');
        const qtyDisplay = wrapper.querySelector('.qty-number');
        const priceDisplay = wrapper.querySelector('.product-total-price');

        const basePrice = parseFloat(wrapper.dataset.basePrice);
        const maxQty = parseInt(wrapper.dataset.maxQty);
        const isUnlimited = wrapper.dataset.unlimited === 'true';
        const canPlaceOrder = wrapper.dataset.canPlaceOrder === 'true';

        if (!canPlaceOrder) {
            return
        }

        let quantity = parseInt(wrapper.dataset.quantity) || 0;

        function toggleButtonState(button, condition) {
            button.classList.toggle('opacity-50', condition);
            button.disabled = condition;
        }

        function updateDisplay() {
            qtyDisplay.textContent = quantity;

            // If price display element exists, update it
            if (priceDisplay) {
                const locale = 'da-DK';

                const formatter = new Intl.NumberFormat(locale, {
                    style: 'decimal',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                });

                function formatPrice(value) {
                    const rounded = Math.round(value * 100) / 100;

                    return Number.isInteger(rounded)
                        ? formatter.format(rounded)
                        : rounded.toLocaleString(locale, {minimumFractionDigits: 2, maximumFractionDigits: 2});
                }

                priceDisplay.textContent = formatPrice(basePrice * quantity);
            }

            toggleButtonState(minusBtn, quantity <= 1);

            if (!isUnlimited) {
                toggleButtonState(plusBtn, quantity >= maxQty);
            } else {
                plusBtn.classList.remove('opacity-50');
                plusBtn.disabled = false;
            }
        }

        minusBtn.addEventListener('click', () => {
            if (quantity > 1) {
                quantity--;
                updateDisplay();
            }
        });

        plusBtn.addEventListener('click', () => {
            if (isUnlimited || quantity < maxQty) {
                quantity++;
                updateDisplay();
            }
        });

        updateDisplay();
    });
}

let $document = $(document);

function setupDropdown() {
    const dropdown = document.querySelector(".dropdown-wrapper");
    if (dropdown) {
        const toggle = dropdown.querySelector(".dropdown-toggle");
        const sortedText = dropdown.querySelector(".sorted-condition");
        const options = dropdown.querySelectorAll(".dropdown-option");


        // Toggle dropdown open/close
        toggle.addEventListener("click", () => {
            dropdown.classList.toggle("open");
        });

        // Close dropdown when clicking outside
        document.addEventListener("click", (e) => {
            if (!dropdown.contains(e.target)) {
                dropdown.classList.remove("open");
            }
        });

        // Handle option click
        options.forEach(option => {
            option.addEventListener("click", () => {
                const sortKey = option.getAttribute("data-sort");

                // Update visible text
                sortedText.textContent = option.textContent.trim();

                // Close dropdown
                dropdown.classList.remove("open");

                // Update URL with ?sort=xxx&page=1 and redirect
                const url = new URL(window.location.href);
                url.searchParams.set("sort", sortKey);
                url.searchParams.set("page", 1);
                window.location.href = url.toString();
            });
        });
    }

    const $navDropdowns = $('.nav-dropdown');
    if ($navDropdowns.length) {
        $navDropdowns.each(function () {
            const $dropdown = $(this);
            const $toggle = $dropdown.find('.dropdown-logo');
            const $menu = $dropdown.find('.category-dropdown-menu');

            // Toggle dropdown
            $toggle.on('click', function (e) {
                e.preventDefault();

                // Close other dropdowns
                $navDropdowns.not($dropdown).removeClass('open');

                // Toggle current dropdown
                $dropdown.toggleClass('open');
            });

            // Prevent menu clicks from closing
            $menu.on('click', function (e) {
                e.stopPropagation();
            });
        });

        // Close all when clicking outside
        $document.on('click', function (e) {
            if (!$(e.target).closest('.category-dropdown-wrapper').length) {
                $navDropdowns.removeClass('open');
            }
        });
    }
}

function setupTextareaCounter(textareaSelector, counterSelector, maxLength = 120) {
    const textarea = document.querySelector(textareaSelector);
    const charCountDisplay = document.querySelector(counterSelector);

    if (textarea && charCountDisplay) {
        const updateCount = () => {
            if (textarea.value.length > maxLength) {
                textarea.value = textarea.value.slice(0, maxLength);
            }
            const remaining = maxLength - textarea.value.length;
            charCountDisplay.textContent = `Tegn tilbage: ${remaining}`;
        };

        charCountDisplay.textContent = `Tegn tilbage: ${maxLength}`;
        textarea.addEventListener('input', updateCount);
        updateCount();
    }
}

$(() => {

        if (window.cartProductError) {
            setTimeout(() => {
                SweetAlert.error(window.cartProductError);
                $('.cart').first().trigger('click');
            }, 50);
        }

        new MobileNavigation();

        navbarHighlight();

        // Dropdown for product blade
        setupDropdown();

        //Product Details Script
        //Order Counter
        setupOrderCounter();


        //Textarea input counter
        setupTextareaCounter('.comments-textarea', '.comments-char-count')

        //Add To Cart Logic
        const basketBtn = $('.basket');
        const $cart = $('.cart');
        const $body = $('body')


        function hideCartPanel() {
            $cartWrapper.removeClass('show');
            $body.removeClass('overflow-hidden');
        }


        if (basketBtn.length) {
            basketBtn.on('click', function () {
                const btn = $(this);
                const productId = btn.data('product-id');
                const variantId = btn.data('variant-id');
                const quantity = parseInt(btn.closest('.quantity').find('.qty-number').text());

                if (quantity <= 0) {
                    return;
                }

                const comment = $('.comments-textarea').val() || '';

                const url = btn.data('url');
                const method = btn.data('method');

                $.ajax({
                    url: url,
                    method: method,
                    data: {
                        product_id: productId,
                        variant_id: variantId,
                        quantity: quantity,
                        comment: comment,
                    },
                    success: function (response) {
                        updateCart(response.item_html, response.cart_item_count)
                        $cart.first().trigger('click');
                    },
                    error: function (xhr) {
                        const res = xhr.responseJSON;
                        if (res?.error) {
                            SweetAlert.error(res.message);
                        } else {
                            SweetAlert.error('Unknown error occurred.');
                        }
                    }
                });
            });
        }


        function updateCart(html, cart_item_count) {
            $cartPopoverWrapper.html(html);

            updateCartItemCount(cart_item_count);

        }

        const $cartWrapper = $('#cart-wrapper')
        const $cartPopoverWrapper = $('#cart-wrapper > .popover:first-child');


        //Toggle Cart
        const body = document.getElementsByTagName("BODY")[0];
        document.querySelectorAll('.cart').forEach(button => {
            button.addEventListener('click', function () {
                body.classList.add('overflow-hidden');
                this.classList.toggle('active');
                $cartWrapper.toggleClass('show');
            });
        });

        function closeCart() {
            $cartWrapper.addClass('hide');

            const $cartWrapperEl = document.getElementById('cart-wrapper');

            const handler = () => {
                $cart.removeClass('active');
                $cartWrapper.removeClass('show hide');
                $body.removeClass('overflow-hidden');

                $cartWrapperEl.removeEventListener('animationend', handler);
                $cartWrapperEl.removeEventListener('transitionstart', handler);
            };

            $cartWrapperEl.addEventListener('animationend', handler);
            $cartWrapperEl.addEventListener('transitionstart', handler);

        }

        // to close cart
        document.body.addEventListener('click', function (event) {
            const btn = event.target.closest('.close-cart');
            const overlay = event.target.className === 'overlay';

            if (btn || overlay) {
                closeCart()
            }
        });

        //To Empty The Whole Cart
        $document.on('click', '.empty-cart', function () {
            const $btn = $(this);
            const url = $btn.data('url');

            if (!url) return;

            $.ajax({
                url: url,
                method: 'DELETE',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                success: function (response) {
                    $cartPopoverWrapper.html(response.item_html);

                    closeCart()

                    if (response.cart_item_count !== undefined) {
                        updateCartItemCount(response.cart_item_count);
                    }
                },
                error: function (xhr) {
                    const res = xhr.responseJSON;
                    if (res?.error) {
                        SweetAlert.error(res.message);
                    } else {
                        SweetAlert.error('Unknown error occurred.');
                    }
                }
            });
        });

        function updateCartItemCount(count) {
            const $badges = $('.cart-item-count');

            $badges.text(count);

            if (parseInt(count) > 0) {
                $badges.removeClass('d-none');
            } else {
                $badges.addClass('d-none');
            }
        }

        $document.on('click', '.checkout-btn:not(.disabled)', function (e) {
            e.preventDefault();

            const $btn = $(this);
            const checkStockUrl = $btn.data('check-stock-url');
            const checkoutUrl = $btn.attr('href');

            $.ajax({
                url: checkStockUrl,
                method: 'POST',
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                },
                success: function (response) {
                    if (response.success) {
                        window.location.href = checkoutUrl;
                    } else {
                        updateCart(response.item_html, response.cart_item_count)
                        if (response.message) {
                            SweetAlert.error(response.message);
                        }
                    }
                },
            });
        });


        //Search Functionality Global Products
        let lastSearch = lastSearchTerm
        let $searchForm = $('.search-form');

        $searchForm.on('submit', function (e) {
            e.preventDefault();
            const $input = $(this).find('input[name="search"]');
            const currentTerm = $input.val().trim();

            if (currentTerm === '') {
                return;
            }

            lastSearch = currentTerm;

            const actionUrl = $(this).attr('action');
            const sortValue = $('input[name="sort"]').val() || '';

            $.ajax({
                url: actionUrl,
                type: 'GET',
                data: {search: currentTerm, sort: sortValue},
                success: function () {
                    window.location.href = actionUrl + '?search=' + encodeURIComponent(currentTerm)
                        + (sortValue ? '&sort=' + encodeURIComponent(sortValue) : '');
                },
                error: function (xhr, status, error) {
                    lastSearch = '';
                }
            });
        });


        let $a = null;

        if (window.pickupDates) {
            $a = initDateTimePicker(window.pickupDates);
        }

        $document.on('submit', '.delete-cart-item-form', function (e) {
            e.preventDefault();


            const form = $(this);
            const url = form.data('url');

            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    _method: 'DELETE',
                },
                success: function (response) {
                    if (response.item_html) {

                        updateCart(response.item_html, response.cart_item_count)

                        if (response.last_item) {
                            hideCartPanel();
                        } else {
                            $('#cart-wrapper').addClass('show');
                        }

                        if (response.pickupDates && $a?.updatePickupDates) {
                            $a.updatePickupDates(response.pickupDates);
                        }

                    }
                },
                error: function (xhr) {
                    const res = xhr.responseJSON;
                    if (res?.message) {
                        SweetAlert.error(res.message);
                    } else {
                        SweetAlert.error('Failed to remove item.');
                    }
                }
            });
        });


        if (document.querySelector('#calendar-container')) {

            let isChecked;

            const $button = $('#confirmBtn');

            $('.checkbox-toggle').on('click', function () {
                const $unchecked = $(this).find('.unchecked-icon');
                const $checked = $(this).find('.checked-icon');

                const currentChecked = $checked.css('display') === 'block';

                if (!currentChecked) {
                    $button.prop('disabled', false)

                } else {
                    $button.prop('disabled', true)
                }

                $checked.css('display', currentChecked ? 'none' : 'block');
                $unchecked.css('display', currentChecked ? 'block' : 'none');

                isChecked = !currentChecked
            });

            //place order
            $button.on('click', function (e) {
                e.preventDefault();

                const url = $(this).data('url');
                if (isChecked) {
                    $.ajax({
                        url: url,
                        method: 'POST',
                        data: {
                            pickup_date: $a.selectedDateTime(),
                            customer_name: $('#customer_name').val(),
                            email: $('#email').val(),
                            phone_number: $('#phone_number').val(),
                        },
                        success: function (response) {
                            window.location.href = response.data.redirect_url;
                        },
                        error: function (xhr) {
                            if (xhr.status === 422) {
                                const errors = xhr.responseJSON.errors;

                                $('.error').text('');
                                $('input').removeClass('input-error');

                                for (const field in errors) {
                                    const message = errors[field][0];
                                    const input = $(`#${field}`);
                                    const errorSpan = input.siblings('.error');

                                    input.addClass('input-error');
                                    errorSpan.text(message);
                                }
                            } else {
                                const response = xhr.responseJSON;
                                let message = response.message.message ?? response.message;
                                SweetAlert.error(message);
                                if (response?.item_html) {
                                    updateCart(response.item_html, response.cart_item_count)
                                    $cart.first().trigger('click');
                                }
                            }
                        },
                    });
                }
            });
        }

        let $subCategory = $('.sub-categories .sub-category');

        if ($subCategory.length > 0) {
            $subCategory.on('click', function (e) {
                e.preventDefault()

                let $this = $(this);
                const isActive = $this.hasClass('selected');
                let targetUrl = $this.attr('href');

                $('.sub-categories .sub-category').removeClass('selected');

                // If already active, reset to base URL
                if (isActive) {
                    const current = new URL(window.location.href);
                    targetUrl = current.origin + current.pathname;
                } else {
                    $this.addClass('selected');
                }

                // Update the URL in the browser (without reload)
                window.history.replaceState({}, '', targetUrl);

                //TODO::setTimeout to run a loader 3sec and clear the timeout in the success & error?

                $.ajax({
                    url: targetUrl,
                    method: 'GET',
                    dataType: 'json',
                    success: function (response) {
                        if (response.html) {
                            $('#products').replaceWith(response.html);
                        }
                    },
                    error: function (err) {
                        console.error(err); //TODO::sweet alert error?
                    }
                });

            })
        }
    }
);




